import SidebarGroup from "../sidebarGroup"
import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/restore.svg'
import RightSidebar from "./RightSidebar"
import { useTranslation } from "react-i18next"
import useAccess from "@/hooks/useAccess"
import { AccessRole } from "@/types"
import useTransactions from "@/hooks/useTransactions"

interface RightSidebarTransactionProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
    transactionId?: string;
}

const RightSidebarTransaction: React.FC<RightSidebarTransactionProps> = ({ 
    className, 
    children, 
    storageId, 
    transactionId 
}) => {

    const { t } = useTranslation()
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    const {
        openDialog,
    } = useLayout()

    const {
        transaction
    } = useTransactions({ storageId, transactionId })

    // Check if transaction can be edited (only drafts and not finalized can be edited)
    const canEdit = !!transaction?.isDraft && !transaction?.isFinalized;

    return (
        <RightSidebar storageId={storageId}>
            <SidebarGroup title={t('menuTransactionActions')} allwaysOpen={true}>
                <SidebarRow onClick={() => openDialog('transaction_history')} text={t('buttonViewHistory')} icon={<HistoryIcon />} style={`border`} />
                {limitToRoles([AccessRole.OWNER, AccessRole.EDITOR, AccessRole.WORKER]) && (
                    <>
                        {canEdit && (
                            <SidebarRow 
                                to={`/storage/transactions/${transactionId}/edit`}
                                text={t('buttonEditTransaction')} 
                                icon={<EditIcon />} 
                                style={`border`} 
                            />
                        )}
                        <SidebarRow 
                            onClick={() => openDialog(`delete_transaction`, {storageId, transactionId})} 
                            text={t('buttonDelete')} 
                            icon={<DeleteIcon />} 
                            style={`border`} 
                        />
                    </>
                )}
            </SidebarGroup>
        </RightSidebar>
    )
}

export default RightSidebarTransaction
